var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { sortByFunc } from '../../../../utils/helper/lodash_replacements';
import { sortedSet } from '../../../../utils/mobx/decorators/customComputed';
import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
export class FunnelBranding {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get funnel() {
        return this.parent;
    }
    get app() {
        return this.funnel.app;
    }
    get brandingTopic() {
        return this.app.model.stream.location['abfrager.de/grundschule/klasse1/sachunterricht/branding'];
    }
    get allBrandings() {
        if (!this.brandingTopic)
            return [];
        if (!this.app.appBoot.isInteractive)
            return [];
        return this.brandingTopic.topicMiniQuestions.miniQuestions;
    }
    get incomingBrandings() {
        return this.allBrandings.filter(mini => mini.miniPassState.questionState === QuestionPassStateId.New);
    }
    get remainingMiniBrandingsSortedByPriority() {
        return this.incomingBrandings
            .concat()
            .sort(sortByFunc((mini) => mini.miniBrandingScore.scoreTotal))
            .reverse();
    }
}
__decorate([
    computed
], FunnelBranding.prototype, "brandingTopic", null);
__decorate([
    sortedSet
], FunnelBranding.prototype, "remainingMiniBrandingsSortedByPriority", null);
